<template>
    <div class="form-group" :class="wrapClasses">
        <label
                class="plh"
                :data-element="checkDataElement('label-'+dataElement)"
                :class="labelClasses"
                v-if="label"
        >
            {{ label }}
        </label>
        <template v-if="mask">
            <input
                    type="text"
                    :name="inputName"
                    :class="inputClasses"
                    :value="value"
                    :disabled="disabled"
                    v-imask="mask"
                    @accept="updateValue($event.detail.unmaskedValue)"
                    @focus="onFocus"
                    @blur="onBlur"
                    :data-element="checkDataElement(dataElement)"
            />
        </template>
        <template v-else>
            <input
                    :name="inputName"
                    :type="inputType"
                    :class="inputClasses"
                    :maxlength="maxLength"
                    :value="value"
                    :disabled="disabled"
                    @input="updateValue($event.target.value)"
                    @focus="onFocus"
                    @blur="onBlur"
                    :data-element="checkDataElement(dataElement)"
            />
        </template>
    </div>
</template>

<script>
/* global Mango */

import {IMaskDirective} from 'vue-imask'

export default {
    name: "FieldInput",
    directives: {
        imask: IMaskDirective
    },
    props: {
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            default: ''
        },
        dataElement: String,
        value: [String, Number],
        label: String,
        size: String,
        disabled: Boolean,
        maxLength: Number,
        error: [String, Boolean]
    },
    data() {
        return {
            isFocused: false
        }
    },
    computed: {
        wrapClasses() {
            let classes = [];

            if (this.error && !this.disabled) {
                classes.push('has-error');
            }

            if (this.isFocused) {
                classes.push('focus');
            }

            if (this.value !== null && this.value !== undefined) {
                if (('' + this.value) !== '') {
                    classes.push('has-value');
                }
            }

            return classes
        },
        inputClasses() {
            let classes = [];

            if (this.size) {
                classes.push(this.size);
            }

            return classes
        },
        labelClasses() {
            let classes = [];

            if (this.size) {
                classes.push(this.size);
            }

            return classes
        },
        inputType() {
            if (this.type === 'file') {
              return 'file'
            }
            if (this.type === 'password') {
              return 'password'
            }
            return 'text'
        },
        inputName() {
          return this.name
        },
        mask() {
            if (this.type === 'phone') {
                return {
                    mask: '{+7}(000)000-00-00'
                }
            }
            return null
        }
    },
    methods: {
        checkDataElement(id) {
            return typeof Mango !== "undefined" ? Mango.checkDataElement(id): false;
        },
        updateValue(value) {
            this.$emit('input', value);
        },
        onFocus() {
            this.isFocused = true
        },
        onBlur() {
            this.isFocused = false
        }
    }
}
</script>

<style scoped>

</style>